module.exports = __webpack_public_path__ + "media/images/logo_p6-95d4b5fca485649c09c6be98a86396f6.svg";